import { render, staticRenderFns } from "./moodul_lisa_info.vue?vue&type=template&id=e10b9c60&"
import script from "./moodul_lisa_info.vue?vue&type=script&lang=js&"
export * from "./moodul_lisa_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports